import { render, staticRenderFns } from "./HorizontalTimeline.vue?vue&type=template&id=5995b248&scoped=true"
import script from "./HorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./HorizontalTimeline.vue?vue&type=script&lang=js"
import style0 from "./HorizontalTimeline.vue?vue&type=style&index=0&id=5995b248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995b248",
  null
  
)

export default component.exports